import { render, staticRenderFns } from "./AdminMasterLayout.vue?vue&type=template&id=45555700&scoped=true&"
import script from "./AdminMasterLayout.vue?vue&type=script&lang=js&"
export * from "./AdminMasterLayout.vue?vue&type=script&lang=js&"
import style0 from "./AdminMasterLayout.vue?vue&type=style&index=0&id=45555700&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45555700",
  null
  
)

export default component.exports